import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  importButton: {
    float: 'right',
  },
  toolbar: {
    margin: theme.spacing(-1, 0),
  },
}));
